var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('AppHeader',{attrs:{"border-bottom":"","justify-space-between":""}}),(_vm.viewToRender)?_c(_vm.viewToRender,{tag:"component",attrs:{"account-data":_vm.accountData},on:{"banking-finished":_vm.bankFinishedHandler}}):_c('AppSpinner'),_c('AppFooter')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }